module.exports = __webpack_public_path__ + "static/media/elo.f9cfe01d.svg";